import { trackEvent } from "../analytics";
import { buildGoogleCalendarUrl, buildOutlookCalendarUrl } from "./googleCalendarLink";
import {
  buildTerminCoPlanShareMessage,
  buildWhatsAppSendUrl,
} from "./whatsAppShare";
import { openWhatsAppUrl } from "./shareMorningBriefing";

/**
 * Share a single Termin for co-planning (not app evangelism).
 * @param {{ title?: string, date?: string, time?: string|null, all_day?: boolean, place?: string|null, source?: string }} event
 */
export async function shareTerminViaWhatsApp(event) {
  const calendarUrl = buildGoogleCalendarUrl(event);
  const outlookUrl = buildOutlookCalendarUrl(event);
  trackEvent("share_whatsapp", {
    scenario: "termin_coplan",
    source: event?.source || "unknown",
  });
  openWhatsAppUrl(
    buildWhatsAppSendUrl(
      buildTerminCoPlanShareMessage({
        title: event?.title,
        date: event?.date,
        time: event?.time,
        all_day: event?.all_day,
        place: event?.place || event?.child || null,
        calendarUrl,
        outlookUrl,
      }),
    ),
  );
}
